import { getFormattedMessage } from 'ui/components/Products/components/ProductList/getFormattedMessage';

export const getItemBadges = (badgeIds: string[], prevState: any) => {
  const foundBadges = badgeIds?.map(
    (badgeId) => getFormattedMessage(`catalog.product.badge.${badgeId}`) || badgeId,
  );
  return foundBadges?.filter((badge) => badge !== undefined).join(',');
};
